import type { ReactNode } from "react";
import { AlertCircle, Inbox, Loader2, ShieldOff } from "lucide-react";
import { Button } from "./Button";
import { cn } from "./cn";

export function Spinner({ label = "Đang tải…", className }: { label?: string; className?: string }) {
  return (
    <div className={cn("flex items-center justify-center gap-2 py-10 text-sm text-ink-3", className)} role="status">
      <Loader2 className="size-4 animate-spin" aria-hidden />
      {label}
    </div>
  );
}

export function EmptyState({
  title,
  description,
  action,
  icon,
  className,
}: {
  title: string;
  description?: ReactNode;
  action?: ReactNode;
  icon?: ReactNode;
  className?: string;
}) {
  return (
    <div className={cn("flex flex-col items-center gap-2 px-6 py-12 text-center", className)}>
      <div className="text-ink-3">{icon ?? <Inbox className="size-6" aria-hidden />}</div>
      <p className="text-sm font-medium text-ink-2">{title}</p>
      {description && <p className="max-w-md text-[13px] text-ink-3">{description}</p>}
      {action && <div className="mt-2">{action}</div>}
    </div>
  );
}

export function ErrorState({ message, onRetry, className }: { message: string; onRetry?: () => void; className?: string }) {
  return (
    <div className={cn("flex flex-col items-center gap-2 px-6 py-10 text-center", className)} role="alert">
      <AlertCircle className="size-6 text-critical-ink" aria-hidden />
      <p className="text-sm text-ink-2">{message}</p>
      {onRetry && (
        <Button size="sm" onClick={onRetry}>
          Thử lại
        </Button>
      )}
    </div>
  );
}

export function Forbidden({ what }: { what: string }) {
  return (
    <EmptyState
      icon={<ShieldOff className="size-6" aria-hidden />}
      title="Không có quyền truy cập"
      description={`Tài khoản của bạn chưa được cấp quyền ${what}. Hãy nhờ quản trị viên cấp quyền; quyền mới có hiệu lực từ lần làm mới phiên tiếp theo.`}
    />
  );
}
